import { MyAccountEmptyStateReadConstants } from "@routes/MyAccount/utils/constants";

/**
 * MyAccountReadingHistoryPopoverEmptyState Component - Empty state for recent reading history popover
 * Figma: https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3623-19473&t=XsTPoO6b0V5zVeJ1-4
 */
const MyAccountReadingHistoryPopoverEmptyState = (): React.ReactElement => {
  return (
    <div
      data-testid="my-account-recent-read-popover-empty-state-component"
      className="text-center"
    >
      <img
        src={MyAccountEmptyStateReadConstants.src}
        alt="my account myBT"
        width={180}
        height={170}
        className="mx-auto mb-8 mt-10"
      />

      <div className="mb-4">
        <p className="font-xs mb-0 font-public-sans text-gray-850">
          {MyAccountEmptyStateReadConstants.afterLoginDescription}
        </p>
      </div>
    </div>
  );
};

export default MyAccountReadingHistoryPopoverEmptyState;
